import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessPatchResponse, PutNoteRequest } from '../types/JobChangeProcess';

export default function useUpdateJobChangeProcessNote() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ jobChangeProcessId, note }: PutNoteRequest) => {
      const response = await fetch(`/agent/api/job_change_processes/${jobChangeProcessId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ note }),
      });
      const data: JobChangeProcessPatchResponse = await response.json();
      return data;
    },
  });
}
